import { getAPI } from '@shared/api/external-api'
import { ComplianceUser, UserProfile } from '@shared/types/user'

export const getUserProfile = async (accessToken?: string) => {
  return await getAPI<UserProfile>('/api/GetProfile', { accessToken })
}

export const getComplianceUserProfile = async (accessToken?: string) => {
  return await getAPI<ComplianceUser>('/custom/api/GetUser', {
    accessToken,
    customAPI: true,
  })
}
